import { createApi } from '@reduxjs/toolkit/query/react'
import { DynamicBaseQueryHeader } from './DynamicBaseQueryHeader'

export const UserNotificationApi = createApi({
  reducerPath: 'UserNotificationApi',
  baseQuery: DynamicBaseQueryHeader('user-notifications'),
  tagTypes: ['UserNotificationSchedules', 'UserNotificationActions', 'UserNotificationDetail'],
  endpoints: (builder) => ({
    getActiveUserNotifications: builder.query({
      query: () => ({
        url: `/active`,
        method: 'GET',
      }),
    }),
    getUserNotificationSchedules: builder.query({
      query: (params: Record<string, any> = {}) => {
        const qs = new URLSearchParams()
        Object.entries(params).forEach(([k, v]) => {
          if (v !== undefined && v !== null && v !== '') qs.set(k, String(v))
        })
        const q = qs.toString()
        return {
          url: q ? `?${q}` : '',
          method: 'GET',
        }
      },
      providesTags: ['UserNotificationSchedules'],
    }),
    getUserNotificationById: builder.query({
      query: (id: number) => ({
        url: `/${id}`,
        method: 'GET',
      }),
      providesTags: (_r, _e, id) => [{ type: 'UserNotificationDetail', id }],
    }),
    createUserNotification: builder.mutation({
      query: (body) => ({
        url: ``,
        method: 'POST',
        body,
      }),
      invalidatesTags: ['UserNotificationSchedules'],
    }),
    updateUserNotification: builder.mutation({
      query: ({ id, ...body }: { id: number } & Record<string, any>) => ({
        url: `/${id}`,
        method: 'PUT',
        body,
      }),
      invalidatesTags: ['UserNotificationSchedules', 'UserNotificationDetail'],
    }),
    cancelUserNotification: builder.mutation({
      query: (id: number) => ({
        url: `/${id}/cancel`,
        method: 'POST',
      }),
      invalidatesTags: ['UserNotificationSchedules', 'UserNotificationDetail'],
    }),
    endUserNotificationNow: builder.mutation({
      query: (id: number) => ({
        url: `/${id}/end-now`,
        method: 'POST',
      }),
      invalidatesTags: ['UserNotificationSchedules', 'UserNotificationDetail'],
    }),
    logUserNotificationAction: builder.mutation({
      query: ({
        id,
        ...body
      }: {
        id: number
        actionTypeId: number
        sessionId?: string
        signalRConnectionId?: string
        pageUrl?: string
      }) => ({
        url: `/${id}/actions`,
        method: 'POST',
        body,
      }),
    }),
    getUserNotificationActions: builder.query({
      query: (params: Record<string, any> = {}) => {
        const qs = new URLSearchParams()
        Object.entries(params).forEach(([k, v]) => {
          if (v !== undefined && v !== null && v !== '') qs.set(k, String(v))
        })
        const q = qs.toString()
        return {
          url: q ? `/actions?${q}` : `/actions`,
          method: 'GET',
        }
      },
      providesTags: ['UserNotificationActions'],
    }),
    getUserNotificationAnalytics: builder.query({
      query: (id: number) => ({
        url: `/${id}/analytics`,
        method: 'GET',
      }),
    }),
  }),
})

export const {
  useGetActiveUserNotificationsQuery,
  useLazyGetActiveUserNotificationsQuery,
  useGetUserNotificationSchedulesQuery,
  useLazyGetUserNotificationByIdQuery,
  useGetUserNotificationByIdQuery,
  useCreateUserNotificationMutation,
  useUpdateUserNotificationMutation,
  useCancelUserNotificationMutation,
  useEndUserNotificationNowMutation,
  useLogUserNotificationActionMutation,
  useGetUserNotificationActionsQuery,
  useGetUserNotificationAnalyticsQuery,
} = UserNotificationApi
